import { getSitemapGenerator } from '@flame-frontend-utils/commons-router6';
import { ROUTES } from './ROUTES';

export const generateSitemapUrls = getSitemapGenerator(ROUTES, PUBLIC_CONFIG.CANONICAL_ROBOTS_HOST);
